import { MAX_KEYWORDS, MAX_KEYWORD_LENGTH } from './constants';

export const parseStreamErrorMessage = (data: string | null | undefined): string | null => {
	if (!data) {
		return null;
	}
	try {
		const parsed = JSON.parse(data);
		return typeof parsed === 'string' && parsed.trim().length > 0 ? parsed : null;
	} catch {
		const raw = data.trim();
		return raw.length > 0 ? raw : null;
	}
};

/** A single typed entry may contain commas (paste, or comma-to-add); split into candidate keywords. */
export const splitKeywordInput = (input: string): string[] =>
	input
		.split(',')
		.map(s => s.trim())
		.filter(Boolean);

/** A keyword is valid when it is non-empty after trimming and within the per-keyword length cap. */
export const isValidKeyword = (keyword: string): boolean => {
	const trimmed = keyword.trim();
	return trimmed.length > 0 && trimmed.length <= MAX_KEYWORD_LENGTH;
};

/**
 * Append candidate keyword(s) to the existing list: trim, drop blank/over-length entries, dedupe
 * case-insensitively, and cap at `MAX_KEYWORDS`. Returns a new array; never mutates `existing`.
 */
export const addKeywords = (existing: string[], additions: string[]): string[] => {
	const seen = new Set(existing.map(k => k.toLowerCase()));
	const next = [...existing];
	for (const candidate of additions) {
		if (next.length >= MAX_KEYWORDS) {
			break;
		}
		const trimmed = candidate.trim();
		if (!isValidKeyword(trimmed)) {
			continue;
		}
		const key = trimmed.toLowerCase();
		if (seen.has(key)) {
			continue;
		}
		seen.add(key);
		next.push(trimmed);
	}
	return next;
};
